export enum DirectionEnum {
  Inbound = 'Inbound',
  Outbound = 'Outbound',
  OneWay = 'One-way',
  Inbound_Outbound = 'Inbound & Outbound',
}
